<script setup lang="ts">
import ErrorBoundary from '~/components/foundations/ErrorBoundary.vue'
import LoadingModal from '~/components/molecules/LoadingModal.vue'
import TheSnackbar from '~/components/organisms/TheSnackbar.vue'
import { useAppEnv } from '~/composables/useAppEnv'
import { useLoading } from '~/composables/useLoading'

const siteTitle = 'Teachme Check'

// https://nuxt.com/docs/getting-started/seo-meta#title-template
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${siteTitle} - ${titleChunk}` : siteTitle
  },
})

const { isProduction, appEnv } = useAppEnv()

const { isActive } = useLoading()
</script>

<template>
  <div>
    <ErrorBoundary>
      <div v-if="!isProduction" class="env-notification">NON-PRODUCTION / {{ appEnv }}</div>
      <LoadingModal :is-active="isActive" />
      <TheSnackbar />
      <div id="page" class="layout-block">
        <NuxtLayout>
          <NuxtPage />
        </NuxtLayout>
      </div>
      <div id="preview" />
      <div id="dialog" />
    </ErrorBoundary>
  </div>
</template>

<style lang="scss" scoped>
.env-notification {
  @include textToken.label-medium;

  position: fixed;
  top: env(safe-area-inset-top, 0px);
  left: 50%;
  z-index: 5;
  transform: translateX(-50%);
  max-width: 100%;
  padding: spacingToken.$spacing-x3s spacingToken.$spacing-m;
  border-radius: 0 0 4px 4px;
  // Environment-only colors, intentionally separate from product design tokens.
  background-color: hsl(204, 86%, 53%);
  color: #fff;
  overflow-wrap: anywhere;
  pointer-events: none;
  user-select: none;
}
.layout-block {
  height: 100vh;
}

#preview {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
}

#dialog {
  position: absolute;
  z-index: 1;
}

#page {
  position: relative;
  z-index: 0;
}
</style>
